import { render, staticRenderFns } from "./JoinWideBlock.vue?vue&type=template&id=370322e1&scoped=true&"
import script from "./JoinWideBlock.vue?vue&type=script&lang=ts&"
export * from "./JoinWideBlock.vue?vue&type=script&lang=ts&"
import style0 from "./JoinWideBlock.vue?vue&type=style&index=0&id=370322e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370322e1",
  null
  
)

export default component.exports